import React from 'react';
import PropTypes from 'prop-types';

import { Loading } from '@comparethemarketau/manor-loading';

import defaultLoadingSpinnerStyles from './loading_spinner.css';

const LoadingSpinner = ({ type }) => {
    if (type === 'CircularProgress') {
        return (
            <div style={{ padding: '3.6rem' }}>
                <Loading type="spinner" messages="" />
            </div>
        );
    }

    return <div className={defaultLoadingSpinnerStyles.spin} />;
};

LoadingSpinner.propTypes = {
    type: PropTypes.oneOf(['Default', 'CircularProgress'])
};

export { LoadingSpinner };
